import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingTimeSinkId } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingSpotlightShown.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentOnboardingSpotlightShownParams = {
  outcome: AgentOnboardingTimeSinkId;
  resolved_preview_id: AgentOnboardingTimeSinkId;
};

export const useTrackAgentOnboardingSpotlightShown = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingSpotlightShown = useCallback(
    (params: UseTrackAgentOnboardingSpotlightShownParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingSpotlightShown };
};
